export class InputMachine {
  constructor(state, context) {
    this.context = context;
    this.sharedIdleState = {
      focus(payload) {
        const { openSelectionImmediately } = payload;
        if (openSelectionImmediately) this.changeStateTo('Focused.Selecting', payload);
        else this.changeStateTo('Focused', payload);
      },
    };
    this.sharedFocusedOnEntry = [
      (payload) => {
        const inputEl = payload && payload.inputEl;
        if (inputEl) {
          this.context.$nextTick(() => {
            inputEl.focus();
          });
        }
      },
    ];
    this.state = state;
    this.changeStateTo(this.state);
  }

  dispatch(actionName, payload) {
    const state = this.transitions()[this.state];
    const action = state[actionName];
    if (action) action.call(this, payload);
  }

  changeStateTo(newState, payload) {
    this.state = newState;
    const { onEntry } = this.transitions()[this.state];
    if (onEntry) onEntry.reduce((prev, func) => func(prev), payload);
  }

  transitions() {
    return {
      Idle: this.sharedIdleState,
      'Idle.Selection': this.sharedIdleState,
      Focused: {
        onEntry: this.sharedFocusedOnEntry,
        select: () => {
          this.changeStateTo('Focused.Selecting');
        },
      },
      'Focused.Selecting': {
        onEntry: this.sharedFocusedOnEntry,
        deselect: () => {
          this.changeStateTo('Focused');
        },
      },
    };
  }
}
